var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isScrollButtonVisible)?_c('div',{staticClass:"scroll-button",on:{"click":_setup.scrollToMessageListBottom}},[_c(_setup.Icon,{attrs:{"width":"10px","height":"10px","file":_setup.doubleArrowIcon}}),_c('div',{staticClass:"scroll-button-text"},[_vm._v(" "+_vm._s(_setup.scrollButtonContent)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }